// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3wPIW","footer":"ChangeClinic_footer__2wSeB"};